import { Flex, Text } from "@chakra-ui/react";
import { TheWashingtonPost, USAToday, WSJ } from "@airhelp/react";
import { useTranslation } from "react-i18next";
import PoweredByLogo from "../../../components/ui-elements/powered-by/PoweredByLogo";
import { useBrand } from "../../../brand/BrandContext";
import styles from "./LeftNavigationBadges.module.scss";
import { isDesktop } from "react-device-detect";
import { proxy } from "valtio";

type DefaultBadgesProps = {
  isOtaSocialProof?: boolean;
};

const otaSocialProof = proxy({
  enabled: window.location.pathname.includes("/ota"),
});

export function enableOtaSocialProof() {
  otaSocialProof.enabled = true;
}

export function DefaultBadges({ isOtaSocialProof }: DefaultBadgesProps) {
  const { t } = useTranslation();
  const color = isOtaSocialProof ? "greyscale.500" : "greyscale.100";

  return (
    <>
      <Text color={color} fontWeight={isOtaSocialProof ? "normal" : "bold"} fontSize="sm">
        {t("left_menu.airhelp_featured")}
      </Text>
      <Flex mt={8}>
        <TheWashingtonPost width="190px" height="30px" color={color} />
      </Flex>
      <Flex mt={8}>
        <USAToday mr={10} width="80px" height="30px" color={color} />
        <WSJ width="57px" height="30px" color={color} />
      </Flex>
    </>
  );
}

function OtaSocialProofDesktopBadges() {
  return (
    <Flex direction="column" align="flex-start" gap={8}>
      <Flex direction="column">
        <PoweredByLogo />
      </Flex>
      <Flex direction="column">
        <DefaultBadges isOtaSocialProof />
      </Flex>
    </Flex>
  );
}

function LeftNavigationBadges() {
  const brand = useBrand();
  const showOtaSocialProof = isDesktop && otaSocialProof.enabled;

  const NavigationBadges = () => {
    if (showOtaSocialProof) return <OtaSocialProofDesktopBadges />;
    if (brand) return <PoweredByLogo />;

    return <DefaultBadges />;
  };

  return (
    <Flex
      direction="column"
      mx="64px"
      my={0}
      position="fixed"
      zIndex={10}
      className={styles.badges}
    >
      <NavigationBadges />
    </Flex>
  );
}

export default LeftNavigationBadges;
